import { render, staticRenderFns } from "./OccupationComponent.vue?vue&type=template&id=08360784"
import script from "./OccupationComponent.vue?vue&type=script&lang=js"
export * from "./OccupationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports